import { ReactElement } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { ScreenTitle } from '../../components/screen-title/screen-title'
import { useRecoilValue } from 'recoil'
import { accountState } from '../../states/accounts-state'
import { useParams } from 'react-router'
import { ProfitSharesList } from '../../components/profit-shares-list/profit-shares-list'
import AccountUserForm from '../../forms/account-user-form'
import { AccountUsersTable } from '../../components/account-users/account-users-table'
import { AccountKyc } from '../../components/account-kyc/account-kyc'
import { AccountContext } from '../../contexts/account-context'
import { SectionHeader } from '../../components/headers/section-header'

const AccountDetailScreen = (): ReactElement => {
  const { accountId } = useParams()
  const account = useRecoilValue(accountState(String(accountId)))

  if (!account) {
    return (
      <Flexbox isCol flex={1}>
        <ScreenTitle title={'No account found'} />
      </Flexbox>
    )
  }

  return (
    <AccountContext.Provider value={accountId || ''}>
      <Flexbox isCol flex={1}>
        <ScreenTitle title={account.name} />
        <AccountKyc />
        <ProfitSharesList />
        <SectionHeader title={'Associated users'} />
        <AccountUsersTable />
        <div>
          {/*<h2>Add user</h2>*/}
          <AccountUserForm />
        </div>
      </Flexbox>
    </AccountContext.Provider>
  )
}

export default AccountDetailScreen